import { string2money } from 'common/utils/string';
import Text from 'components/elements/text';
import * as React from 'react';

import { CruiseContainer } from './styles';
import { CruisePurchaseAddOnsItemFormType } from '../form-type';

interface Props {
  data: CruisePurchaseAddOnsItemFormType;
  isGrouped?: boolean;
}

export default function SummaryAddOnsItem(props: Props) {
  const { data, isGrouped } = props;
  const label: string = isGrouped
    ? [data.guestName, data.description?.toUpperCase()]
        .filter((val) => !!val)
        .join(' | ')
    : data.description?.toUpperCase();

  return (
    <CruiseContainer>
      {/* <CruiseContent> */}
      <Text variant="LabelSmall">{label}</Text>
      {/* </CruiseContent> */}
      <Text variant="LabelSmall">{`Rp ${string2money(data.price)}`}</Text>
    </CruiseContainer>
  );
}
